module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/perform.js
// module id = 999
// module chunks = 0